var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 98,
    viewBox: "0 0 378 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.588 69.7774L195.542 1.77882H180.264V96.2212H196.509V25.751L259.692 96.2212H272.833V1.77882H256.588V69.7774Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7783 1.77882H0V96.2212H73.3243V80.1332H16.7783V1.77882Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.348 1.59358L285.836 1.77882V96.2212L330.348 96.4064C356.666 96.4064 378 75.1824 378 49C378 22.8176 356.666 1.59358 330.348 1.59358ZM330.348 80.1331H302.617V17.8669H330.348C347.632 17.8669 361.643 31.8056 361.643 49C361.643 66.1944 347.632 80.1331 330.348 80.1331Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.578 0C95.3748 0 73.3242 21.9371 73.3242 49C73.3242 76.0629 95.3748 98 122.578 98C142.422 98 159.512 86.3197 167.312 69.4958H147.511C141.578 76.6313 132.612 81.1786 122.575 81.1786C106.631 81.1786 93.3878 69.6962 90.7249 54.5927H171.497C171.709 52.7556 171.826 50.893 171.826 49C171.831 21.9371 149.778 0 122.578 0ZM122.578 16.8188C136.928 16.8188 149.089 26.1215 153.321 38.9945H91.8319C96.0635 26.1215 108.225 16.8188 122.578 16.8188V16.8188Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/default_logo.ac344c4f.svg";
export { ForwardRef as ReactComponent };